import { render, staticRenderFns } from "./PresentacionesIndex.vue?vue&type=template&id=221e9a46&"
import script from "./PresentacionesIndex.vue?vue&type=script&lang=js&"
export * from "./PresentacionesIndex.vue?vue&type=script&lang=js&"
import style0 from "./PresentacionesIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports